import axios from './http'
import Router from '@/router/index'
import IP from '@/common/ip'

let api_root = '/LockWeb/v1'

const api = {
  // 获取当前IP
  getHostName: axios.defaults.baseURL,
  // 获取某个权限
  hasUserPermission(uri) {
    let btnPermissionList = JSON.parse(localStorage.getItem('buttonList'))
    let status = btnPermissionList.includes(uri)
    return status
  },
  // 登录
  login: (params, config) => {
    return fetch('/user/login', params, config)
  },
  // 忘记密码
  forgetPass: (params, config) => {
    return fetch('/user/answer', params, config)
  },
  // 退出登录
  logout: (params, config) => {
    return fetch('/user/logout', params, config)
  },
  getMenu: (params, config) => {
    return fetch('/permission/menu', params, config)
  },
  // 获取按钮显示列表
  getBtnList: (params, config) => {
    return fetch('/permission/button', params, config)
  },
  // 上传图片
  uploadImgUrl: axios.defaults.baseURL + api_root + '/images/upload',
  // 下载图片
  downImgUrl: axios.defaults.baseURL + api_root + '/images/down/',
  // ---------------------数据总览---------------------------
  getOverview: (params, config) => {
    return fetch('/data/overview', params, config)
  },
  // ---------------------周转房大屏---------------------------
  bigScreenZzf: (params, config) => {
    return fetch('/data/zzf_board', params, config)
  },
  // ---------------------归寝监控---------------------------
  getWsUrl: IP.OutIp,
  // ---------------------业务管理---------------------------
  // 远程开门
  remoteOpen: (params, config) => {
    return fetch('/lock/remoteOpen', params, config)
  },
  // 获取远程开设备列表
  roomLockList: (params, config) => {
    return fetch('/room_lock/list', params, config)
  },
  // 获取应急开设备列表
  urgentLockList: (params, config) => {
    return fetch('/area_gate/list', params, config)
  },
  // 应急开门
  urgentOpen: (params, config) => {
    return fetch('/lock/urgentOpen', params, config)
  },
  // ---------------------租赁管理--------------------------
  // 获取权限下发列表
  getTentManage: (params, config) => {
    return fetch('/tent_manage/list', params, config)
  },
  // 操作完成
  doneTentManage: (params, config) => {
    return fetch('/tent_manage/done', params, config)
  },
  // ---------------------告警管理（锁 烟感）-----------------
  // 告警列表
  getDevAlarmList: (params, config) => {
    return fetch('/dev_alarm/list', params, config)
  },
  // 告警确认
  confirmDevAlarm: (params, config) => {
    return fetch('/dev_alarm/confirm', params, config)
  },
  // ---------------------抄表管理--------------------------
  // 抄表
  addMeterRead: (params, config) => {
    return fetch('/meter_read/add', params, config)
  },
  // 抄表修改
  editMeterRead: (params, config) => {
    return fetch('/meter_read/edit', params, config)
  },
  // 抄表记录
  getMeterReadList: (params, config) => {
    return fetch('/meter_read/list', params, config)
  },
  // 抄表记录导出
  exportMeterRead: (params, config) => {
    return fetch('/meter_read/export', params, config)
  },
  // ---------------------公告管理--------------------------
  // 获取公告
  getNoticeOne: (params, config) => {
    return fetch('/notice/get', params, config)
  },
  // 编辑公告
  editNotice: (params, config) => {
    return fetch('/notice/edit', params, config)
  },
  // ---------------------入住管理--------------------------
  // 获取入住列表
  getHotelList: (params, config) => {
    return fetch('/hotel/list', params, config)
  },
  // 新增入住
  addHotel: (params, config) => {
    return fetch('/hotel/add', params, config)
  },
  // 更换房间
  hotelChange: (params, config) => {
    return fetch('/hotel/change', params, config)
  },
  // 续住
  hotelDelay: (params, config) => {
    return fetch('/hotel/delay', params, config)
  },
  // 删除入住
  hotelDel: (params, config) => {
    return fetch('/hotel/del', params, config)
  },
  // ---------------------访客管理--------------------------
  // 新增访客
  visitorAdd: (params, config) => {
    return fetch('/visitor/add', params, config)
  },
  // 访客列表
  getVisitorList: (params, config) => {
    return fetch('/visitor/list', params, config)
  },
  // 访客离开
  visitorLeave: (params, config) => {
    return fetch('/visitor/leave', params, config)
  },
  // 部门下被访人列表
  getInterList: (params, config) => {
    return fetch('/person/inter_list', params, config)
  },
  // ---------------------人员管理--------------------------
  //人员卡号生成
  getPersonNewNo: (params, config) => {
    return fetch('/person/no_gen', params, config)
  },
  // 人员管理列表
  getPersonList: (params, config) => {
    return fetch('/person/list', params, config)
  },
  // 人员管理添加
  addPerson: (params, config) => {
    return fetch('/person/add', params, config)
  },
  // 人员管理编辑
  editPerson: (params, config) => {
    return fetch('/person/edit', params, config)
  },
  // 人员小程序密码重置
  resetPersonPassword: (params, config) => {
    return fetch('/person/passwordReset', params, config)
  },
  // 人员管理删除
  delPerson: (params, config) => {
    return fetch('/person/del', params, config)
  },
  // 人员管理详情
  getPersonInfo: (params, config) => {
    return fetch('/person/info', params, config)
  },
  // 人员授权
  personAuth: (params, config) => {
    return fetch('/person_lock/edit', params, config)
  },
  // 批量授权
  multiPersonAuth: (params, config) => {
    return fetch('/person_lock/batch_add', params, config)
  },
  // 批量删除授权
  multiDelPersonAuth: (params, config) => {
    return fetch('/person_lock/batch_del', params, config)
  },
  // 获取已有授权
  getPersonAuthList: (params, config) => {
    return fetch('/person_lock/list', params, config)
  },
  // 导入
  importPerson: axios.defaults.baseURL + '/person/import',
  // 导出
  exportPerson: (params, config) => {
    return nFetch('/person/export', params, config)
  },
  // ----------------------------介质相关--------------------------
  // 取消录入 拿到medium.js里了
  // 读取介质 拿到medium.js里了
  // ----------------------------指纹介质相关--------------------------
  // 获取指纹数据
  getFprintList: (params, config) => {
    return fetch('/med_fprint/list', params, config)
  },
  // 添加指纹,
  addFprint: (params, config) => {
    return fetch('/med_fprint/add', params, config)
  },
  // 指纹解挂
  editFprint: (params, config) => {
    return fetch('/med_fprint/edit', params, config)
  },
  // 指纹删除
  delFprint: (params, config) => {
    return fetch('/med_fprint/del', params, config)
  },
  // ----------------------------ic介质相关--------------------------
  // 获取ic数据
  getIcList: (params, config) => {
    return fetch('/med_ic/list', params, config)
  },
  // 添加ic,
  addIc: (params, config) => {
    return fetch('/med_ic/add', params, config)
  },
  // ic解挂
  editIc: (params, config) => {
    return fetch('/med_ic/edit', params, config)
  },
  // ic删除
  delIc: (params, config) => {
    return fetch('/med_ic/del', params, config)
  },
  // ----------------------------静脉介质相关--------------------------
  // 获取静脉数据
  getFveinList: (params, config) => {
    return fetch('/med_fvein/list', params, config)
  },
  // 添加静脉,
  addFvein: (params, config) => {
    return fetch('/med_fvein/add', params, config)
  },
  // 静脉解挂
  editFvein: (params, config) => {
    return fetch('/med_fvein/edit', params, config)
  },
  // 静脉删除
  delFvein: (params, config) => {
    return fetch('/med_fvein/del', params, config)
  },
  // ----------------------------身份证介质相关--------------------------
  // 获取身份证数据
  getIdList: (params, config) => {
    return fetch('/med_id/list', params, config)
  },
  // 添加身份证,
  addId: (params, config) => {
    return fetch('/med_id/add', params, config)
  },
  // 身份证解挂
  editId: (params, config) => {
    return fetch('/med_id/edit', params, config)
  },
  // 身份证删除
  delId: (params, config) => {
    return fetch('/med_id/del', params, config)
  },
  // ----------------------------录入密码相关--------------------------
  getPassList: (params, config) => {
    return fetch('/med_passwd/list', params, config)
  },
  addPassInfo: (params, config) => {
    return fetch('/med_passwd/add', params, config)
  },
  delPassInfo: (params, config) => {
    return fetch('/med_passwd/del', params, config)
  },

  // ---------------------门禁规则管理--------------------------
  // 门禁组列表
  getPassGroupList: (params, config) => {
    return fetch('/pass_group/list', params, config)
  },
  // 门禁组添加
  addPassGroup: (params, config) => {
    return fetch('/pass_group/add', params, config)
  },
  // 门禁组编辑
  editPassGroup: (params, config) => {
    return fetch('/pass_group/edit', params, config)
  },
  // 门禁组删除
  delPassGroup: (params, config) => {
    return fetch('/pass_group/del', params, config)
  },
  // 门禁组详情
  getPassGroupInfo: (params, config) => {
    return fetch('/pass_group/info', params, config)
  },
  // 门禁规则列表
  getPassRuleList: (params, config) => {
    return fetch('/pass_rule/list', params, config)
  },
  // 门禁规则添加
  addPassRule: (params, config) => {
    return fetch('/pass_rule/add', params, config)
  },
  // 门禁规则编辑
  editPassRule: (params, config) => {
    return fetch('/pass_rule/edit', params, config)
  },
  // 门禁规则删除
  delPassRule: (params, config) => {
    return fetch('/pass_rule/del', params, config)
  },
  // 门禁批量规则删除
  batchDelPassRule: (params, config) => {
    return fetch('/pass_rule/batch_del', params, config)
  },
  // 门禁规则详情
  getPassRuleInfo: (params, config) => {
    return fetch('/pass_rule/info', params, config)
  },
  // ---------------------归寝记录---------------------------
  getPersonReturnList: (params, config) => {
    return fetch('/person_return/list', params, config)
  },
  // ---------------------宿管日志---------------------------
  getDormLogList: (params, config) => {
    return fetch('/dorm_log/list', params, config)
  },
  addDormLog: (params, config) => {
    return fetch('/dorm_log/add', params, config)
  },
  editDormLog: (params, config) => {
    return fetch('/dorm_log/edit', params, config)
  },
  getDormLogInfo: (params, config) => {
    return fetch('/dorm_log/info', params, config)
  },
  delDormLog: (params, config) => {
    return fetch('/dorm_log/del', params, config)
  },
  batchDelDormLog: (params, config) => {
    return fetch('/dorm_log/batch_del', params, config)
  },
  // ---------------------考勤管理---------------------------
  // 考勤时间
  getTime: (params, config) => {
    return fetch('/work_time/list', params, config)
  },
  // 设置时间
  setTime: (params, config) => {
    return fetch('/work_time/edit', params, config)
  },
  // 获取考勤锁列表
  getWorkLock: (params, config) => {
    return fetch('/work_lock/list', params, config)
  },
  // 添加考勤点位
  addWorkLock: (params, config) => {
    return fetch('/work_lock/edit', params, config)
  },
  // 考勤管理列表
  getWorkRecordList: (params, config) => {
    return fetch('/work_report/list', params, config)
  },
  // 导出考勤报表
  exportWork: (params, config) => {
    return fetch('/work_report/export', params, config)
  },
  // 导出考勤记录（打开点的打卡记录）
  exportRecordWork: (params, config) => {
    return fetch('/work_report/record_export', params, config)
  },
  // ---------------------设备管理---------------------------
  // 网关管理列表
  getGateList: (params, config) => {
    return fetch('/gate/list', params, config)
  },
  // 网关添加
  addGate: (params, config) => {
    return fetch('/gate/add', params, config)
  },
  // 网关编辑
  editGate: (params, config) => {
    return fetch('/gate/edit', params, config)
  },
  // 网关删除
  delGate: (params, config) => {
    return fetch('/gate/del', params, config)
  },
  // 网关详情
  getGateInfo: (params, config) => {
    return fetch('/gate/info', params, config)
  },
  // 读取网关
  getLoraGate: (params, config) => {
    return fetch('/gate/getLora', params, config)
  },
  // 设置网关
  setLoraGate: (params, config) => {
    return fetch('/gate/setLora', params, config)
  },
  // 更换网关
  changeGate: (params, config) => {
    return fetch('/gate/replace', params, config)
  },
  // ---------------------设备管理---------------------------
  // 设备管理列表
  getLockList: (params, config) => {
    return fetch('/lock/list', params, config)
  },
  // 设备添加
  addLock: (params, config) => {
    return fetch('/lock/add', params, config)
  },
  // 设备编辑
  editLock: (params, config) => {
    return fetch('/lock/edit', params, config)
  },
  // 设备删除
  delLock: (params, config) => {
    return fetch('/lock/del', params, config)
  },
  // 设备历史记录清除
  lockHisClear: (params, config) => {
    return fetch('/lock/hisClear', params, config)
  },
  // 设备介质一键删除
  delLockMed: (params, config) => {
    return fetch('/lock/allDel', params, config)
  },
  // 设备介质一键删除
  delLockTypeMed: (params, config) => {
    return fetch('/lock/typeDel', params, config)
  },
  // 下发时间组
  sendTime: (params, config) => {
    return fetch('/lock/period', params, config)
  },
  // 下发假日组
  sendHoliday: (params, config) => {
    return fetch('/lock/holiday', params, config)
  },
  // 设置工作模式
  setDevWorkMode: (params, config) => {
    return fetch('/lock/workMode', params, config)
  },
  // 设备详情
  getLockInfo: (params, config) => {
    return fetch('/lock/info', params, config)
  },
  getLoraLock: (params, config) => {
    return fetch('/lock/getLora', params, config)
  },
  getStatLock: (params, config) => {
    return fetch('/lock/getStat', params, config)
  },
  setLoraLock: (params, config) => {
    return fetch('/lock/setLora', params, config)
  },
  // 蓝牙
  getLockBlue: (params, config) => {
    return fetch('/lock/getBlue', params, config)
  },
  setLockBlue: (params, config) => {
    return fetch('/lock/setBlue', params, config)
  },
  // 更换设备
  changeLock: (params, config) => {
    return fetch('/lock/replace', params, config)
  },
  // ---------------------防火设备管理---------------------------
  // 获取防火设备列表
  getFacilitieList: (params, config) => {
    return fetch('/firefacilities/list', params, config)
  },
  // 获取设备详情
  getFacilitieInfo: (params, config) => {
    return fetch('/firefacilities/info', params, config)
  },
  // 编辑防火设备
  editFacilitie: (params, config) => {
    return fetch('/firefacilities/edit', params, config)
  },
  // 获取设备告警列表
  getFacilitieAlarmList: (params, config) => {
    return fetch('/facilitie_alarm/list', params, config)
  },
  // 告警确认
  confirmFacilitieAlarm: (params, config) => {
    return fetch('/facilitie_alarm/confirm', params, config)
  },
  // ---------------------设备初始化管理---------------------------
  getLockInit: (params, config) => {
    return fetch('/lock_init/get', params, config)
  },
  setLockInit: (params, config) => {
    return fetch('/lock_init/set', params, config)
  },
  // ---------------------报修管理---------------------------
  // 获取报修列表
  getRepairList: (params, config) => {
    return fetch('/repair/list', params, config)
  },
  // 添加报修
  addRepair: (params, config) => {
    return fetch('/repair/add', params, config)
  },
  // 添加报修
  editSubmitRepair: (params, config) => {
    return fetch('/repair/edit', params, config)
  },
  // 编辑报修信息
  editRepair: (params, config) => {
    return fetch('/repair/repair', params, config)
  },
  // 导出
  exportRepair: (params, config) => {
    return fetch('/repair/export', params, config)
  },
  // ---------------------人员机构管理---------------------------
  // 获取人员机构列表
  getDepartmentList: (params, config) => {
    return fetch('/department/list', params, config)
  },
  // 获取人员机构树结构
  getDepartmentTree: (params, config) => {
    return fetch('/department/tree', params, config)
  },
  // 获取机构管理树结构
  getDepartmentTreeManage: (params, config) => {
    return fetch('/department/tree_man', params, config)
  },
  // 删除人员机构
  delDepartment: (params, config) => {
    return fetch('/department/del', params, config)
  },
  // 添加人员机构
  addDepartment: (params, config) => {
    return fetch('/department/add', params, config)
  },
  // 获取人员机构信息
  getDepartmentInfo: (params, config) => {
    return fetch('/department/info', params, config)
  },
  // 编辑人员机构
  editDepartment: (params, config) => {
    return fetch('/department/edit', params, config)
  },
  // ---------------------授权记录查询管理---------------------------
  // 授权列表
  getAuthRecordList: (params, config) => {
    return fetch('/auth_record/list', params, config)
  },
  // 重做按钮
  redoAuth: (params, config) => {
    return fetch('/auth_record/redo', params, config)
  },
  // ---------------------记录查询管理---------------------------
  // 获取记录查询列表
  getPersonRecordList: (params, config) => {
    return fetch('/person_record/list', params, config)
  },
  // 删除记录查询
  delPersonRecord: (params, config) => {
    return fetch('/person_record/del', params, config)
  },
  // 添加记录查询
  addPersonRecord: (params, config) => {
    return fetch('/person_record/add', params, config)
  },
  // 获取记录查询信息
  getPersonRecordInfo: (params, config) => {
    return fetch('/person_record/info', params, config)
  },
  // 编辑记录查询
  editPersonRecord: (params, config) => {
    return fetch('/person_record/edit', params, config)
  },
  // 导出
  exportPersonRecord: (params, config) => {
    return fetch('/person_record/export', params, config)
  },
  // ---------------------组织机构管理---------------------------
  // 获取组织机构列表
  getAreaList: (params, config) => {
    return fetch('/area/list', params, config)
  },
  // 获取组织机构树结构
  getAreaTree: (params, config) => {
    return fetch('/area/tree', params, config)
  },
  // 获取组织机构管理树结构
  getAreaTreeManage: (params, config) => {
    return fetch('/area/tree_man', params, config)
  },
  // 删除组织机构
  delArea: (params, config) => {
    return fetch('/area/del', params, config)
  },
  // 添加组织机构
  addArea: (params, config) => {
    return fetch('/area/add', params, config)
  },
  // 获取组织机构信息
  getAreaInfo: (params, config) => {
    return fetch('/area/info', params, config)
  },
  // 编辑组织机构
  editArea: (params, config) => {
    return fetch('/area/edit', params, config)
  },
  // ---------------------房间管理---------------------------
  // 获取房间列表
  getRoomList: (params, config) => {
    return fetch('/room/list', params, config)
  },
  // 删除房间 （暂时没用到）
  delRoom: (params, config) => {
    return fetch('/room/del', params, config)
  },
  // 批量删除房间
  batchDelRoom: (params, config) => {
    return fetch('/room/batch_del', params, config)
  },
  // 添加房间
  addRoom: (params, config) => {
    return fetch('/room/add', params, config)
  },
  // 获取房间信息
  getRoomInfo: (params, config) => {
    return fetch('/room/info', params, config)
  },
  // 编辑房间
  editRoom: (params, config) => {
    return fetch('/room/edit', params, config)
  },
  // 导入
  importRoom: axios.defaults.baseURL + '/room/import',
  // 导出
  exportRoom: (params, config) => {
    return fetch('/room/export', params, config)
  },
  // ---------------------房型管理---------------------------
  // 获取房型列表
  getRoomTypeList: (params, config) => {
    return fetch('/room_type/list', params, config)
  },
  // 删除房型
  delRoomType: (params, config) => {
    return fetch('/room_type/del', params, config)
  },
  batchDelRoomType: (params, config) => {
    return fetch('/room_type/batch_del', params, config)
  },
  // 添加房型
  addRoomType: (params, config) => {
    return fetch('/room_type/add', params, config)
  },
  // 获取房型信息
  getRoomTypeInfo: (params, config) => {
    return fetch('/room_type/info', params, config)
  },
  // 编辑房型
  editRoomType: (params, config) => {
    return fetch('/room_type/edit', params, config)
  },
  // ---------------------归寝管理---------------------------
  // 获取归寝列表
  getBedTimeList: (params, config) => {
    return fetch('/time_window/list', params, config)
  },
  // 获取归寝信息
  getBedTimeInfo: (params, config) => {
    return fetch('/time_window/info', params, config)
  },
  // 编辑归寝
  editBedTime: (params, config) => {
    return fetch('/time_window/edit', params, config)
  },
  // ---------------------假日管理---------------------------
  // 获取假日列表
  getHolidayList: (params, config) => {
    return fetch('/holiday/list', params, config)
  },
  // 删除假日
  delHoliday: (params, config) => {
    return fetch('/holiday/del', params, config)
  },
  batchDelHoliday: (params, config) => {
    return fetch('/holiday/batch_del', params, config)
  },
  // 添加假日
  addHoliday: (params, config) => {
    return fetch('/holiday/add', params, config)
  },
  // 获取假日信息
  getHolidayInfo: (params, config) => {
    return fetch('/holiday/info', params, config)
  },
  // 编辑假日
  editHoliday: (params, config) => {
    return fetch('/holiday/edit', params, config)
  },
  // ---------------------时段管理---------------------------
  // 获取时段列表
  getTimeList: (params, config) => {
    return fetch('/time_slot/list', params, config)
  },
  // 获取时段信息
  getTimeInfo: (params, config) => {
    return fetch('/time_slot/info', params, config)
  },
  // 编辑时段
  editTime: (params, config) => {
    return fetch('/time_slot/edit', params, config)
  },
  // ---------------------角色管理---------------------------
  // 获取角色列表
  getRoleList: (params, config) => {
    return fetch('/role/list', params, config)
  },
  // 删除角色
  delRole: (params, config) => {
    return fetch('/role/del', params, config)
  },
  batchDelRole: (params, config) => {
    return fetch('/role/batch_del', params, config)
  },
  // 添加角色
  addRole: (params, config) => {
    return fetch('/role/add', params, config)
  },
  // 获取角色信息
  getRoleInfo: (params, config) => {
    return fetch('/role/info', params, config)
  },
  // 编辑角色
  editRole: (params, config) => {
    return fetch('/role/edit', params, config)
  },
  // ---------------------用户管理---------------------------
  // 获取用户列表
  getUserList: (params, config) => {
    return fetch('/user/list', params, config)
  },
  // 删除用户
  delUser: (params, config) => {
    return fetch('/user/del', params, config)
  },
  // 添加用户
  addUser: (params, config) => {
    return fetch('/user/add', params, config)
  },
  // 获取用户信息
  getUserInfo: (params, config) => {
    return fetch('/user/info', params, config)
  },
  // 编辑用户
  editUser: (params, config) => {
    return fetch('/user/edit', params, config)
  },
  // 重置密码
  resetPassword: (params, config) => {
    return fetch('', params, config)
  },
  // ---------------------字典管理---------------------------
  // 获取字典列表
  getTypeList: (params, config) => {
    return fetch('/dict_type/list', params, config)
  },
  // 删除字典
  delType: (params, config) => {
    return fetch('/dict_type/del', params, config)
  },
  // 添加字典
  addType: (params, config) => {
    return fetch('/dict_type/add', params, config)
  },
  // 获取字典信息
  getTypeInfo: (params, config) => {
    return fetch('/dict_type/info', params, config)
  },
  // 编辑字典
  editType: (params, config) => {
    return fetch('/dict_type/edit', params, config)
  },
  // 获取字典详细列表
  getItemList: (params, config) => {
    return fetch('/dict/list', params, config)
  },
  // 删除字典详细
  delItem: (params, config) => {
    return fetch('/dict/del', params, config)
  },
  batchDelItem: (params, config) => {
    return fetch('/dict/batch_del', params, config)
  },
  // 添加字典详细
  addItem: (params, config) => {
    return fetch('/dict/add', params, config)
  },
  // 获取字典详细信息
  getItemInfo: (params, config) => {
    return fetch('/dict/info', params, config)
  },
  // 编辑字典详细详细
  editItem: (params, config) => {
    return fetch('/dict/edit', params, config)
  },
  // ---------------------维修人员---------------------------
  // 维修人员列表
  getRepairManList: (params, config) => {
    return fetch('/repairman/list', params, config)
  },
  // 删除维修人员
  delRepairMan: (params, config) => {
    return fetch('/repairman/del', params, config)
  },
  batchDelRepairMan: (params, config) => {
    return fetch('/repairman/batch_del', params, config)
  },
  // 添加维修人员
  addRepairMan: (params, config) => {
    return fetch('/repairman/add', params, config)
  },
  // 获取维修人员信息
  getRepairManInfo: (params, config) => {
    return fetch('/repairman/info', params, config)
  },
  // 编辑维修人员
  editRepairMan: (params, config) => {
    return fetch('/repairman/edit', params, config)
  },
  // ---------------------系统菜单---------------------------
  // 获取菜单列表
  getMenuList: (params, config) => {
    return fetch('/permission/list', params, config)
  },
  // 获取菜单列表
  getMenuTreeList: (params, config) => {
    return fetch('/permission/tree', params, config)
  },
  // 删除菜单
  delMenu: (params, config) => {
    return fetch('/permission/del', params, config)
  },
  // 添加菜单
  addMenu: (params, config) => {
    return fetch('/permission/add', params, config)
  },
  // 获取菜单信息
  getMenuInfo: (params, config) => {
    return fetch('/permission/info', params, config)
  },
  // 编辑菜单
  editMenu: (params, config) => {
    return fetch('/permission/edit', params, config)
  },
  // ---------------------系统日志---------------------------
  getSysLogList: (params, config) => {
    return fetch('/sys_log/list', params, config)
  },
  // ---------------------个人设置---------------------------
  setUserInfo: (params, config) => {
    return fetch('/user/self', params, config)
  },
  // ---------------------系统设置---------------------------
  // 获取系统设置信息
  getSysInfo: (params, config) => {
    return fetch('/param/info', params, config)
  },
  // 设置系统设置信息
  setSysInfo: (params, config) => {
    return fetch('/param/edit', params, config)
  }
}

const procData = (data, cb, err) => {
  let tmpCode = data.code.toString()
  switch (tmpCode) {
    case '200':
      cb(data.result)
      break
    case '605':
      err(data.message)
      localStorage.clear()
      Router.replace({
        path: '/login'
      })
      break
    default:
      err(data.message)
  }
}

const fetch = (url, params, config) => {
  let c = config || ''
  let v = api_root + url
  return axios.post(v, params, c).then((res) => {
    return {
      res: res.data,
      procData: procData
    }
  })
}
// 导出用
const nFetch = (url, params, config) => {
  let c = config || ''
  let v = api_root + url
  return axios.post(v, params, c).then((res) => {
    return {
      res: res.data
    }
  })
}
export default api
